import React from 'react'
import styled from 'styled-components'

const Container = styled.div`
     border-top: 1px solid #e1e4ed;
     padding: 15px 10px;
`

export const Trustbox = () => {
  // Create a reference to the <div> element which will represent the TrustBox
  const ref = React.useRef(null)
  React.useEffect(() => {
    // If window.Trustpilot is available it means that we need to load the TrustBox from our ref.
    // If it's not, it means the script you pasted into <head /> isn't loaded  just yet.
    // When it is, it will automatically load the TrustBox.
    if (window.Trustpilot) {
      window.Trustpilot.loadFromElement(ref.current, true)
    }
  }, [])
  return (
    <Container
      ref={ref} // We need a reference to this element to load the TrustBox in the effect.
      className="trustpilot-widget" // Renamed this to className.
     data-locale="da-DK" data-template-id="5419b6a8b0d04a076446a9ad" data-businessunit-id="5f830220e1d0f900017ca234" data-style-height="24px" data-style-width="100%" data-theme="light"
      // [ long list of data attributes...]
    >
      <a
        href="https://www.trustpilot.com/review/typeandmore.dk"
        target="_blank"
        rel="noopener"
      >
        {' '}
        Trustpilot
      </a>
    </Container>
  )
}
